export const enum CooldownBypassTypes {
  EXPEND_ENDURANCE_CHARGE = 1,
  EXPEND_FRENZY_CHARGE = 2,
  EXPEND_POWER_CHARGE = 3,
  NONE = 4
}

export const enum ItemFlags {
  None = 0,
  Corrupted = 0x0001,
  Shaper = 0x0002,
  Elder = 0x0004,
  Crusader = 0x0008,
  Hunter = 0x0010,
  Redeemer = 0x0020,
  Warlord = 0x0040,
  SearingExarch = 0x0080,
  EaterOfWorlds = 0x0100,
  Fractured = 0x0200,
  Synthesized = 0x0400,
  Veiled = 0x0800,
  Archnemesis = 0x1000,
  Experimented = 0x2000
}

export type InventorySlotType =
  | 'Amulet'
  | 'Belt'
  | 'BodyArmour'
  | 'Boots'
  | 'Gloves'
  | 'Helm'
  | 'Ring'
  | 'Ring2'
  | 'Flask1'
  | 'Flask2'
  | 'Flask3'
  | 'Flask4'
  | 'Flask5'
  | 'Weapon'
  | 'Offhand'
  | 'Weapon2'
  | 'Offhand2'
  | `Jewel${number}`
